/* eslint-disable no-use-before-define */
import React from 'react'
import { useOrderTicket, } from './use-order-ticket'
import { Errors } from './errors'

export const Header = () => {
    const { step, isRfq, action } = useOrderTicket()

    const title = step==='entry' && ['W','F'].indexOf(action)>=0 ? 'Quote request'
        : step==='entry' ? 'Bond order'
        : step==='preview' && !isRfq ? 'Preview bond order'
        : step==='preview' && isRfq ? 'Preview quote request'
        : step==='confirm' && !isRfq ? 'Order confirmation'
        : step==='confirm' && isRfq ? 'Quote request confirmation'
        : ''

    return <React.Fragment>
        <div className="row vertical-offset-xs">
        <div className="col-md-6 col-xs-12">
            <h2 className="large-header">{title}</h2>
        </div>
        <div className="col-md-6 col-xs-12 text-body text-right">
        Talk to a Fixed Income Specialist. Call <a
            style={{textDecoration:'underline'}}
            alt="877-355-3237"
            href="tel:18773553237"
            aria-label="877-355-3237">877-355-3237</a>
        </div>
        </div>

        <Errors />

        </React.Fragment>
}
